module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_headphones-379e096d5e9276ba21a102b31c3674cf.svg";